const defaultProperties = {
  backgroundColor: '#FFFFFF',
  textColor: '#000000',
  topPadding: true,
  bottomPadding: true,
  id: 'card-container-unique-id',
  dataId: 'unique-id',
  background: '#FFFFFF',
  enableContainerPage: false,
};
export default (contentHtml, style = '', properties = {}) => {
  const finalProperties = {
    ...defaultProperties,
    ...properties,
  };
  return `
    ${style ? `<style>${style}</style>` : ''}
    <div
      data-attribute="card-container"
      id="${finalProperties.id}"
      data-id="${finalProperties.dataId}"
      data-background="${finalProperties.backgroundColor}"
      data-top-padding="${finalProperties.topPadding}"
      data-bottom-padding="${finalProperties.bottomPadding}"
      data-text-color="${finalProperties.textColor}"
      style="background-color: ${finalProperties.backgroundColor}; color: ${finalProperties.textColor}; --text-color: ${
    finalProperties.textColor
  };">
      <div class="container-page"
        data-attribute="container-page"
        data-enable-style="${finalProperties.enableContainerPage}"
        data-background-container="#FFFFFF" style="background-color: transparent;">
          ${contentHtml}
      </div>
    </div>
  `;
};
